import { render, staticRenderFns } from "./CalificarCursoModalComponent.vue?vue&type=template&id=2610a61e"
import script from "./CalificarCursoModalComponent.vue?vue&type=script&lang=js"
export * from "./CalificarCursoModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports